module.exports = __webpack_public_path__ + "assets/img/hero-placeholder.d868548a.svg";